export function Esqueleto({ lineas = 3 }: { lineas?: number }) {
  return (
    <div className="animate-pulse space-y-2">
      {Array.from({ length: lineas }).map((_, i) => (
        <div key={i} className="bg-surface h-5 rounded" />
      ))}
    </div>
  );
}

export function EstadoVacio({ titulo, detalle }: { titulo: string; detalle?: string }) {
  return (
    <div className="text-muted py-10 text-center">
      <p className="font-semibold">{titulo}</p>
      {detalle && <p className="mt-1 text-contenido">{detalle}</p>}
    </div>
  );
}
